<template>
  <div class="extension g-tile">
    <div
      class="extension__head"
      :class="{ 'u-clickable': !disabled }"
      @click="setExtended(!extended)"
    >
      <div class="u-flex-grow font-semibold">
        <slot name="header" :extended="extended" />
      </div>
      <div
        v-if="showArrow && !disabled"
        class="extension__icon u-flex-shrink-0"
      >
        <yt-button-arrow :dir="extended ? 'up' : 'down'" />
      </div>
    </div>
    <slide-toggle>
      <div v-if="extended || isSSR" class="extension__body">
        <div class="extension__body-container font-regular">
          <slot name="body" />
        </div>
      </div>
    </slide-toggle>
  </div>
</template>

<script>
import YtButtonArrow from "@/components/ui-kit/yt-button-arrow/index.vue";
import SlideToggle from "@/components/ui-kit/slide-toggle/index.vue";

export default {
  components: {
    YtButtonArrow,
    SlideToggle,
  },
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      extended: false,
      isSSR: vueOptions.ssr
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(extended) {
        this.setExtended(extended);
      },
    },
  },
  methods: {
    setExtended(extended) {
      if (this.disabled) {
        return;
      }

      this.extended = extended;
      this.$emit("change", extended);
      this.$emit("toggle", extended);
    },
  },
};
</script>

<style lang="scss" scoped>
$b: ".extension";

#{$b} {
  + #{$b} {
    margin-top: 20px;
  }

  &__head,
  &__body {
    padding-right: 20px;
    padding-left: 20px;

    @include mixin.size-md-only {
      padding-right: 24px;
      padding-left: 24px;
    }

    @include mixin.size-xl-min {
      padding-right: 24px;
      padding-left: 24px;
    }
  }

  &__head {
    display: flex;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  &__body {
    &-container {
      padding-bottom: 20px;

      @include mixin.size-md-only {
        padding-bottom: 24px;
      }

      @include mixin.size-xl-min {
        padding-bottom: 24px;
      }
    }
  }

  &__icon {
    margin-left: 2em;
  }
}
</style>
